import { parse, stringify as _stringify } from 'qs';

export const getUrlQuery = () => {
    const search = window.location.search;

    const originalQuery = parse(search.slice(1)) || {};
    const filteredQuery: { [index: string]: any } = Object.keys(originalQuery).reduce(
        (filtered, cur) => {
            const curVal = originalQuery[cur];
            return Object.assign(filtered, {
                [cur]: Array.isArray(curVal) ? curVal[curVal.length - 1] : curVal
            });
        },
        {}
    );
    return filteredQuery;
};
/**
 *formatUrl 格式化url
 *@base: url的path
 *@query: 需要拼接的参数
 */

export const formatUrl = (base: string, query: { [index: string]: any } = {}) => {
    if (typeof base !== 'string') throw new Error('path should be string');

    return Object.keys(query)
        .reduce(
            (concated, key) => concated + (query[key] ? `${key}=${query[key]}&` : ''),
            base.indexOf('?') !== -1 ? base : `${base}?`
        )
        .slice(0, -1);
};

export const delParams = (keys: string[], base: string = location.origin + location.pathname) => {
    const searchParams = { ...getUrlQuery() };
    keys.forEach((key) => {
        delete searchParams[key];
    });

    const newSearch = Object.keys(searchParams).reduce((acc, cur) => {
        return acc + `${cur}=${searchParams[cur]}&`;
    }, '?');

    return base + newSearch.substr(0, newSearch.length - 1);
};

export default getUrlQuery();
export const stringify = _stringify;
